<template>
  <v-container fluid class="mt-2">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-btn
            v-if="!vertical && showGridSettings"
            @click.stop="gridColumnsDialogShow(true)"
            fab
            small
            top
            right
            absolute
            class="mr-14"
          >
            <v-icon> mdi-cog </v-icon>
          </v-btn>
          <v-btn v-if="!vertical" v-on:click="$emit('refresh')" fab small top right absolute>
            <v-icon> mdi-refresh </v-icon>
          </v-btn>
          <v-card-title>
            <v-row>
              <v-col cols="12" md="8" class="mt-md-1" v-if="!hideFilters">
                <v-select
                  v-model="filters"
                  :items="filterItems"
                  prepend-icon="mdi-filter-menu"
                  attach
                  dense
                  chips
                  item-value="code"
                  item-text="name"
                  :label="$_t(filterName)"
                  multiple
                  @input="inputFilter"
                ></v-select>
              </v-col>
              <slot name="filters"></slot>
              <v-col cols="12" md="4" v-if="!hideSearch">
                <GridSearch
                  v-model="search"
                  :label="$_t('Search')"
                ></GridSearch>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table
              ref="table"
              :headers="headers"
              :items="innerDataFiltered"
              item-key="value"
              :sort-desc="sortDesc"
              :multi-sort="multiSort"
              :disable-pagination="disablePagination"
              :hide-default-footer="hideDefaultFooter"
              :items-per-page="itemsPerPage"
              :loading="loading"
              :class="classLocal"
              :search="search"
              :sort-by="sortBy"
              :mobile-breakpoint="vertical ? 9999 : 500"
              :disable-sort="vertical || disableSort"
              @click:row="rowClicked"
              :fixed-header="fixedHeader"
              :height="fixedHeader ? '100vh' : ''"
              :options.sync="gridOptions"
              :server-items-length="serverItemsLength"
              :footer-props="{
                'items-per-page-options':[15, 30, 50, 100],
                'items-per-page-text':$_t('Rows per page')
              }"
              :loading-text="$_t('Loading items...')"
              v-sortable-table="{onEnd:sortTheHeadersAndUpdateTheKey}"
              :key="anIncreasingNumber"

            >
              <template v-slot:item.isActive="{ item }">
                {{ item.isActive ? "Yes" : "No" }}
              </template>
              <template v-slot:item.appointmentId="{ item }">
                {{ item.appointmentIdShort ? item.appointmentIdShort : 'A' + item.appointmentId.substr(item.appointmentId.length - 11) }}
              </template>
              <template v-slot:item.patientId="{ item }">
                <span v-if="item.patientId">
                  {{ item.patientIdShort ? item.patientIdShort : 'P' + item.patientId.substr(item.patientId.length - 11) }}
                </span>
              </template>
              <template v-slot:item.appointmentStatusName="{ item }">
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: (item.appointmentStatusColorCodeWeb || item.appointmentStatusColorCode || '').replace(
                        '^',
                        '#'
                      ),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.appointmentStatusNameWeb || item.appointmentStatusName }}
              </template>
              <template v-slot:item.appointmentStatusNameStyled="{ item }">
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: '#' + (item.appointmentStatusNameStyled || '').split('^').pop()
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ (item.appointmentStatusNameStyled || '').split('^')[0] }}
              </template>
              <template v-slot:item.appointmentProcedureStatusName="{ item }">
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                  v-if="item.appointmentProcedureStatusName"
                >
                  <v-avatar
                    :style="{
                      background: '#' + (item.appointmentProcedureStatusName || '').split('^').pop(),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.appointmentProcedureStatusName ? item.appointmentProcedureStatusName.split('^').shift() : '' }}
              </template>


              <template v-slot:item.procedureName="{ item }">
                <AppointmentPracticeSplitSlot :item="item.procedureName" />
              </template>
               <template v-slot:item.duration="{ item }">
                 <AppointmentPracticeSplitSlot :item="item.duration" />
                </template>
              <template v-slot:item.insurerName="{ item }">
                <AppointmentPracticeSplitSlot :item="item.insurerName" />
              </template>

              <template v-slot:item.clinicScanRoomCode="{ item }">
                <AppointmentPracticeSplitSlot :item="item.clinicScanRoomCode" />
              </template>
              <template v-slot:item.cancelReason="{ item }">
                <AppointmentPracticeSplitSlot :item="item.cancelReason" />
              </template>
              <template
                v-slot:item.appointmentProtocollingStatusName="{ item }"
              >
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: (item.appointmentProtocollingStatusColorCode || '').replace(
                        '^',
                        '#'
                      ),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.appointmentProtocollingStatusName }}
              </template>
              <template
                v-slot:item.appointmentDocumentStatusName="{ item }"
              >
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: (item.appointmentDocumentStatusColorCode || '').replace(
                        '^',
                        '#'
                      ),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.appointmentProtocollingStatusName }}
              </template>
              <template
                v-slot:item.appointmentSourceName="{ item }"
              >
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: (item.appointmentSourceColorCode || '').replace(
                        '^',
                        '#'
                      ),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.appointmentSourceName }}
              </template>
               <template
                v-slot:item.appointmentCategoryName="{ item }"
              >
                 <v-avatar
                   :style="{ border: '1px solid black' }"
                   rounded
                   size="28"
                   class="mr-3"
                 >
                   <v-avatar
                     :style="{
                      background: (item.appointmentCategoryColorCode || '').replace(
                        '^',
                        '#'
                      ),
                    }"
                     rounded
                     size="22"
                   >
                   </v-avatar>
                 </v-avatar>
                {{ item.appointmentCategoryName }}
              </template>
               <template
                v-slot:item.appointmentCategoryNameStyled="{ item }"
              >
                {{ (item.appointmentCategoryNameStyled || '').split('^').shift() }}
              </template>
              <template
                v-slot:item.appointmentPriorityName="{ item }"
              >
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: item.appointmentPriorityColorCode ? item.appointmentPriorityColorCode.replace(
                        '^',
                        '#'
                      ) : '',
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.appointmentPriorityName }}
              </template>
              <template
                v-slot:item.appointmentPriorityNameStyled="{ item }"
              >
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: '#' + (item.appointmentPriorityNameStyled || '').split('^').pop(),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ (item.appointmentPriorityNameStyled || '').split('^').shift() }}
              </template>
              <template v-slot:item.alertStatusName="{ item }">
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: (
                        item.alertStatusColorCode || '^555555'
                      ).replace('^', '#'),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.alertStatusName }}
              </template>
              <template v-slot:item.alertTypeName="{ item }">
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar
                    :style="{
                      background: (
                        item.alertTypeColorCode || '^555555'
                      ).replace('^', '#'),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.alertTypeName }}
              </template>
              <template v-slot:item.appointmentDate="{ item }">
                {{
                  item.appointmentDate
                    ? useHumanDate(item.appointmentDate)
                    : ""
                }}
              </template>
              <template v-slot:item.dateOfBirth="{ item }">
                {{
                  item.dateOfBirth
                    ? useHumanDate(item.dateOfBirth)
                    : ""
                }}
              </template>

              <template v-slot:item.startTime="{ item }" >
                <div v-if="item.startTime">
                  <div v-if="!item.startTime.includes('<br>')">
                    {{ item.startTime ? item.startTime.substring(0, 5) : '' }}
                  </div>
                  <div v-else>
                    <div v-for="split in splitData(item.startTime)" :key="split">
                      <div>{{(split || "").replace(/([0-9]{2}\:[0-9]{2}).*/, "$1")}}</div>
                    </div>
                  </div>
                </div>

              </template>

              <template v-slot:item.patient="{ item }">
                {{
                  [item.title, item.firstName, item.lastName].filter((el) => el && el.trim()).join(' ')
                }}
              </template>
              <template v-slot:item.appointmentDateCreated="{ item }">
                {{
                  item.appointmentDateCreated ? useHumanDateTimeSec(item.appointmentDateCreated) : ''
                }}
              </template>
              <template v-slot:item.sex="{ item }">
                {{
                  item.sex === 'M' ? 'Male' : (item.sex === 'F' ? 'Female' : item.sex)
                }}
              </template>

              <template v-slot:item.patientDateOfBirth="{ item }">
                {{
                  item.patientDateOfBirth ? useHumanDate(item.patientDateOfBirth) : ''
                }}
              </template>
              <template v-slot:item.patientFullName="{ item }">
                {{
                  item.patientFullName
                }}
              </template>
              <template v-slot:item.patientIdExternal="{ item }">
                {{
                  item.patientIdExternal
                }}
              </template>
              <template v-slot:item.patientNumber1="{ item }">
                {{
                  item.patientNumber1
                }}
              </template>
              <template v-slot:item.practitionerFullName="{ item }">
                {{
                  [item.practitionerFullName, item.practiceName].filter((el) => el && el.trim()).join(' ')
                }}
              </template>
              <template v-slot:item.secondaryPractitionerFullName="{ item }">
                {{
                  [item.secondaryPractitionerFullName, item.secondaryPracticeName].filter((el) => el && el.trim()).join(' ')
                }}
              </template>
              <template v-slot:item.appointmentSpecialityName="{ item }">
                {{
                  item.appointmentSpecialityName
                }}
              </template>
              <template v-slot:item.patientEpisodeStatusName="{ item }">
                <v-avatar
                  :style="{ border: '1px solid black' }"
                  rounded
                  size="28"
                  class="mr-3"
                >
                  <v-avatar v-if="item.patientEpisodeStatusColorCode"
                    :style="{
                      background: (item.patientEpisodeStatusColorCode || '').replace(
                        '^',
                        '#'
                      ),
                    }"
                    rounded
                    size="22"
                  >
                  </v-avatar>
                </v-avatar>
                {{ item.patientEpisodeStatusName }}
              </template>
              <template v-slot:item.isAppointmentCancelRequested="{ item }">
                <v-checkbox
                  color="primary"
                  :input-value="toBoolean(item.isAppointmentCancelRequested)"
                  disabled
            ></v-checkbox>
              </template>
              <template v-slot:item.currentHospitalLocationPointOfCare="{ item }">
                <PatientLocationSlot v-if="item.patientLocationId" :item="item.patientLocationJson" />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <GridColumns
      :all-columns="getAllHeadersGridColumns"
      :dialog="gridColumnsDialog"
      :selected-columns.sync="gridColumnsSelected"
      @hide="gridColumnsDialogShow"
      @save="saveGridColumns"
      @drop="drop"
    >
    </GridColumns>
  </v-container>
</template>

<script>
import GridSearch from '@src/components/common/grid-elements/GridSearch.vue'
import AppointmentPracticeSplitSlot from '@/src/components/common/grid-elements/AppointmentPracticeSplitSlot.vue'
import PatientLocationSlot from '@/src/components/common/grid-elements/PatientLocationSlot.vue'
import useDateHelpers from '../../helpers/useDateHelpers';
import useCommonHelpers from '../../helpers/useCommonHelpers';

import GridColumns from '@src/components/common/grid-elements/GridColumns.vue'
import Sortable from 'sortablejs'
import vue from 'vue'
import config from '@src/config'
const { useHumanDateTime, useHumanDate, useHumanDateTimeSec } = useDateHelpers()
const { parseJson } = useCommonHelpers()
function watchClass(targetNode, classToWatch) {
  let lastClassState = targetNode.classList.contains(classToWatch);
  const observer = new MutationObserver((mutationsList) => {
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const currentClassState = mutation.target.classList.contains(classToWatch);
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;
          if (!currentClassState) {
            mutation.target.classList.add('sortHandle');
          }
        }
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}
export default {
  components:{GridSearch,AppointmentPracticeSplitSlot,GridColumns, PatientLocationSlot},
  value: 'AppointmentGrid',
  props: {
    headersPresetType: {
      type: String,
      default: ''
    },
    headersPreset: {
      type: Array,
      default: ()=>[]
    },
    columns: {
      type: Array,
      default: ()=>[]
    },
    data: {
      type: Array,
      default: () => []
    },
    sortBy: {
      type: Array,
      default: () => []
    },
    sortDesc: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean
    },
    showAddRow: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    },
    hideSearch: {
      type: Boolean,
      default: false
    },
    filterByColumnName: {
      type: String,
      default: 'appointmentStatusName'
    },
    filterName: {
      type: String,
      default: 'Appointment Status'
    },
    fixedHeader:{
      type:Boolean,
      default:false
    },
    gridCode: {
      type: String,
      default: null
    },
    showGridSettings: {
      type: Boolean,
      default: false
    },
    disablePagination: {
      type: Boolean,
      default: true
    },
    disableSort: {
      type: Boolean,
      default: true
    },
    itemsPerPage: {
      type: Number,
      default: 50
    },
    hideDefaultFooter: {
      type: Boolean,
      default: true
    },
    serverItemsLength: {
      type: Number,
      default: -1
    },
    searchValue: {
      type: String,
      default: ''
    },
    multiSort: {
      type: Boolean,
      default: true
    },
    alertStatuses: {
      type: Array,
      default: () => []
    },
    gridClass: {
      type: null,
      default: ''
    }
  },
  data() {
    return {
      useHumanDateTime: useHumanDateTime,
      useHumanDate: useHumanDate,
      useHumanDateTimeSec: useHumanDateTimeSec,
      innerData:[],
      filterItems: [],
      filters: [],
      gridColumnsDialog:false,
      gridColumnsSelected: [],
      gridOptions: {},
      anIncreasingNumber: 1,
      sorting: {}
    };
  },
  mounted() {
    this.innerData = [...this.data]
    this.gridColumnsSelected = [...this.storedColumns]
  },
  methods: {
    sortTheHeadersAndUpdateTheKey(evt) {
      if(this.sortColumnsOnGrid) {
        const newArray = []
        const oldIndex = evt.oldIndex;
        const newIndex = evt.newIndex;
        this.headers.splice(newIndex, 0,this.headers.splice(oldIndex, 1)[0])
        this.headers.forEach(el=>{
          newArray.push(el.value)
        })
        const toSave = newArray.filter(el=>typeof el !== 'undefined')
        this.gridColumnsSelected = toSave;
        this.anIncreasingNumber += 1;
        this.saveGridColumns()
      }
    },
    gridColumnsDialogShow (param) {
      this.gridColumnsDialog = param
    },
    splitData(dataToSplit){
       const set = new Set(dataToSplit.split('<br>'))
          return [...set]
    },
    inputFilter(val){
    if(val.length > 0 ) {
          this.innerData = this.data.filter(data=>{
            switch (this.filterByColumnName) {
              case 'currentHospitalLocationPointOfCare':
                if(data.patientLocationId) {
                  const json = parseJson(data.patientLocationJson)
                  if(json?.pointOfCare && typeof json.pointOfCare === 'string' && json.pointOfCare.trim()) {
                    if(val.includes(json.pointOfCare.trim())) {
                      return data
                    }
                  }
                }
                break;

              default:
              if(val.includes(data[this.filterByColumnName])) {
                return data
              }
              break;
            }

          })
      } else {
        this.innerData = [...this.data]
      }
      this.processFilters()

    },
    processFilters() {
      let filterArray = [];
      this.data.filter(data => {
        switch (this.filterByColumnName) {
          case 'currentHospitalLocationPointOfCare':
            if(data.patientLocationId) {
              const json = parseJson(data.patientLocationJson)
              if(json?.pointOfCare && typeof json.pointOfCare === 'string' && json.pointOfCare.trim()) {
                filterArray.push(json.pointOfCare.trim());
              }
            }
            break;
          case 'alertStatusCode':
            filterArray = this.alertStatuses

            break;
          default:
            filterArray.push(data[this.filterByColumnName])
            break;
        }

      });

      this.filterItems = [
        ...new Set(filterArray)
      ];
      return this.filterItems
    },
    rowClicked(row) {
      this.$emit('rowClick', row)
    },
    drop(columns){
      this.gridColumnsSelected = [...columns]
    },
    saveGridColumns(){
      this.$store.dispatch('app/setColumnsByPresetType',{presetType:this.headersPresetType,columns:this.gridColumnsSelected}).then(()=>{
        this.$store.commit('app/setRefreshed',true)
      })

      this.gridColumnsDialogShow(false)
    }
  },
  computed: {
    classLocal () {
      let baseClass = ['elevation-1']
      let propsClass = this.gridClass
      if (propsClass && typeof propsClass === 'string') {
        propsClass = propsClass.split(' ')
      }
      if (Array.isArray(propsClass)) {
        baseClass = [...baseClass, ...propsClass]
      }
      return baseClass
    },
    storedColumns() {
      return this.$store.getters['app/columns'](this.headersPresetType)
    },
    sortColumnsOnGrid() {
      return this.$store.getters['app/getSortColumnsOnGrid']
    },
    getAllHeadersGridColumns() {
      let headerColumnsVisible = this.headersPreset.filter(column=>column.visible)
      if(typeof config['defaultColumnsGrid_'+this.headersPresetType] !== 'undefined' && config['defaultColumnsGrid_'+this.headersPresetType].length) {
        const configColumns = config['defaultColumnsGrid_'+this.headersPresetType]
        headerColumnsVisible = this.headersPreset.filter(column=>column.visible && configColumns.includes(column.value))
      }
      headerColumnsVisible.forEach((el)=>{
        if(this.gridColumnsSelected.length) {
          el.selected = !!this.gridColumnsSelected.find(column=>column === el.value)
        }
      })

      return headerColumnsVisible
    },

    getInnerData() {
      return this.innerData
    },
    headers() {
      let columns = []
      if(!this.showGridSettings) {
        columns = this.headersPreset.filter(column=>column.visible)
        if(typeof config['defaultColumnsGrid_'+this.headersPresetType] !== 'undefined' && config['defaultColumnsGrid_'+this.headersPresetType].length) {
        const configColumns = config['defaultColumnsGrid_'+this.headersPresetType]
        columns = this.headersPreset.filter(column=>column.visible && configColumns.includes(column.value))
      }
      } else {
      columns =  this.storedColumns.map(column => {
        return this.headersPreset.find(
          header => header.value === column
        )
      })
      }
      columns = Object.values(columns.filter(el => !!el))
      if (columns.length) {
        for(const item of columns) {
          if (item) {
            item.text = this.$_t(item.text).toString()
          }
        }
      }
      return columns
    },
    innerDataFiltered() {
      if(!this.hideFilters)  this.processFilters()
      return Array.isArray(this.innerData) ? this.innerData.filter(item => {
        return item
      }) : []
    },
    search: {
      get() {
        return this.searchValue;
      },
      set(val) {
        this.$emit('update:searchValue', val);
      }
    }
  },
  watch: {
    data: {
      handler: function (val) {
        if (val.length > 0){
          this.innerData = JSON.parse(JSON.stringify(val)).map(row => {
            Object.entries(row).map(([key, value]) => {
              let newValue = value
              if (typeof value === 'string') {
                newValue = value.replace(/&nbsp;/g, ' ').trim()
              }
              row[key] = newValue
            })
            return row
          })
        } else {
          this.innerData = []
        }
        if (this.filters.length) {
          this.inputFilter(this.filters);
        }
      },
      deep: true
    },
    gridOptions(val) {
        this.$emit('grid-options-changed', val)
    },
    searchValue(val) {
      this.$emit('grid-search', val)
    }
  },
  directives: {
    'sortable-table': {

      inserted: (el, binding,vnode) => {

        el.querySelectorAll('th').forEach((draggableEl) => {
          watchClass(draggableEl, 'sortHandle');
          draggableEl.classList.add('sortHandle');
        });
          if(vnode.context.sortColumnsOnGrid) {
           Sortable.create(el.querySelector('tr'), binding.value ? { ...binding.value, handle: '.sortHandle' } : {});
          }
      },
    },
  }
};
</script>
